module.exports = __webpack_public_path__ + "static/media/shipsyLogo.3b340d49.svg";